import { useNavigate, useLocation } from 'react-router-dom';
import { FaUserCircle, FaChevronDown } from 'react-icons/fa';
import { useState, useRef, useEffect } from 'react';
import ProfileModal from './ProfileModal';

import logo from '../assets/logo.png';


export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);

  const [showDropdown, setShowDropdown] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));

  const [showProfileModal, setShowProfileModal] = useState(false);

const handleProfile = () => {
  setShowDropdown(false);
  setShowProfileModal(true);
};

  

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

 

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // 🔥 Hide header only on `/` (auth page)
  if (
    location.pathname === '/' ||
    location.pathname === '/forgot-password' ||
    location.pathname.startsWith('/verify')
  ) {
    return null;
  }

  return (
    <header className="mx-2 md:mx-12 bg-white shadow-sm px-6 py-4 flex justify-between items-center">
      <img
        src={logo}
        alt="Logo"
        className="w-56 cursor-pointer"
        onClick={() => navigate('/companies')}
      />

      <div className="relative" ref={dropdownRef}>
        <button
          className="flex items-center gap-2 text-gray-700 font-medium hover:text-primary"
          onClick={toggleDropdown}
        >
          <FaUserCircle className="text-2xl" />
          <FaChevronDown className="text-sm" />
        </button>

        {showDropdown && (
          <div className="absolute right-0 mt-2 w-40 bg-white border rounded-md shadow-lg py-2 z-50">
            <button
              onClick={handleProfile}
              className="w-full text-left px-4 py-2 hover:bg-gray-100"
            >
              Profile
            </button>
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 hover:bg-gray-100 text-red-500"
            >
              Logout
            </button>
          </div>
        )}
      </div>
      {showProfileModal && (
  <ProfileModal
    user={user}
    onClose={() => setShowProfileModal(false)}
  />
)}

    </header>
  );
}
